/*
export const API_URL = "http://localhost:12033/api/";
export const SESSION_COOKIE = "userLocalLovetoDripedBAtm";
export const MIGRATION_DOMAIN = "https://lovedripptestapp.tsdevcut.co.za/wp-json/ts/migration/list/v1/";
*/

export const API_URL = "https://lovedripp-api.onrender.com/api/";
export const SESSION_COOKIE = "userLiveLiverpoolLovetoDripedBATMAN";
export const MIGRATION_DOMAIN = "https://loved.tsdevcut.co.za/wp-json/ts/migration/list/v1/";


export const URL_HOME = "https://lovedripp.co.za/";
export const URL_BLOG = "https://blogger.lovedripp.co.za/";

export const SMALL_PROCESSING = "https://tsdevcut.co.za/factory/proc_sm.gif";
//export const URL_HOME = "https://lovedripp.tsdevcut.co.za/";